import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { isValidElement, useContext } from 'react';
import clsx from 'clsx';
import { Icon } from '../icon';
import Badge from '../badge';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var ActionBarIcon = function ActionBarIcon(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('action-bar-icon', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var renderIcon = function renderIcon() {
    var badge = props.badge,
        icon = props.icon,
        color = props.color,
        iconClass = props.iconClass,
        iconPrefix = props.iconPrefix;

    if (typeof icon === 'string') {
      return /*#__PURE__*/React.createElement(Icon, {
        tag: "div",
        name: icon,
        badge: badge,
        color: color,
        className: clsx(bem('icon'), iconClass),
        classPrefix: iconPrefix
      });
    }

    if ( /*#__PURE__*/isValidElement(icon)) {
      return /*#__PURE__*/React.createElement(Badge, _extends({}, badge, {
        className: clsx(bem('icon'))
      }), icon);
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: clsx(props.className, bem()),
    style: props.style,
    tabIndex: 0,
    onClick: props.onClick
  }, renderIcon(), props.children || props.text);
};

export default ActionBarIcon;